module.exports = __webpack_public_path__ + "assets/img/logo-nav.2d8949a9.png";